// extracted by mini-css-extract-plugin
export default {"informationBlock":"EmptyInformationBlock_informationBlock__MxiAx","icon":"EmptyInformationBlock_icon__Xady5"};